

import React, { useState, useEffect, useRef } from 'react';
 import'./taxes-grid.css';
import {  Divider, Table, Popconfirm, Card, Tooltip, Switch,Input,Button, Row, Col, Drawer, Tag, } from 'antd';
import Highlighter from 'react-highlight-words';
import {  TaxesDto } from '@gtpl/shared-models/masters';
import { ColumnProps } from 'antd/lib/table';
import { FormattedMessage } from 'react-intl';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { useIntl } from 'react-intl';
import {TaxesForm} from '@gtpl/pages/master/master-components/taxes-form';
import {TaxesService} from '@gtpl/shared-services/masters'
import {RightSquareOutlined,EyeOutlined,EditOutlined,SearchOutlined,CheckCircleOutlined,CloseCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
export interface TaxesGridProps {
  // StatesData: StatesDto[];
  //  viewState: (State: StatesDto, viewOnly: boolean) => void;
  // deleteState: (State: StatesDto) => void;
}

export const TaxesGrid = (props:  TaxesGridProps) => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const columns = useState('');
  const [taxesData, setTaxesData] = useState<TaxesDto[]>([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedTaxesData, setSelectedTaxesData] = useState<any>(undefined);

  const service = new TaxesService;

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={ searchInput }
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex]
    ? record[dataIndex]
       .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {    setTimeout(() => searchInput.current.select());   }
    },
    render: text =>
      text ?(
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) :text
      )
      : null
     
  });
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

  useEffect(() => {
    getAllTaxes();
  }, []);


  const getAllTaxes= () => {
  service.getAllTaxes().then(res => {
      if (res.status) {
        setTaxesData(res.data);
      } else {
        if (res.intlCode) {
          setTaxesData([]);
            // AlertMessages.getErrorMessage(res.internalMessage);
        } else {
        //  AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setTaxesData([]);
      // AlertMessages.getErrorMessage(err.message);
    })
  }
/**
   * 
   * @param TaxesData 
   */
  const deleteTax = (taxesDto:TaxesDto) => {
    taxesDto.isActive=taxesDto.isActive?false:true;
    service.ActivateOrDeactivateTax(taxesDto).then(res => { console.log(res);
      if (res.status) {
        getAllTaxes();
        AlertMessages.getSuccessMessage('Success');
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  };
      /**
     * 
     * @param variantData 
     */
    const updateTax = (taxesData: TaxesDto) => {
      service.updateTax(taxesData).then(res => {
        if (res.status) {
          AlertMessages.getSuccessMessage('Updated Successfully');
          getAllTaxes();
          setDrawerVisible(false);
        } else {
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
      })
    }

// Example data
    const data =[{
      taxId:'1',
      taxName:'tax',
      taxPercentage:'0',
      status:'true'
    }]
  const sampleTypeColumns: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      responsive: ['sm'],
      render: (text, object, index) => (page-1) * 10 +(index+1)
    
    },
    // {
    //   title: 'Tax Id',
    //   dataIndex: 'taxId',
    //   // responsive: ['lg'],
    //   ...getColumnSearchProps('taxId')
    // },
    {
      title: 'Tax Name',
      dataIndex: 'taxName', 
      // responsive: ['lg'],
      sorter: (a, b) => a.taxName.localeCompare(b.taxName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('taxName')
    },
    {
      title: 'Tax Percentage(%)',
      dataIndex: 'taxPercentage', 
      // responsive: ['lg'],
      sorter: (a, b) => a.taxPercentage - b.taxPercentage,
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('taxPercentage')
    },
    {
      title:'Tax Category',
      dataIndex:'taxCategory',
      filters: [
        {
          text: 'State',
          value: 'State',
        },
        {
          text: 'Central',
          value: 'Central',
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => 
      {
     
        return record.taxCategory === value;
      },
      // sorter: (a,b) => a.taxCategory - b.taxCategory,
      // sortDirections: ['descend', 'ascend'],
      // ...getColumnSearchProps('taxCategory')
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
       render: (isActive, rowData) => (
        <>
          {isActive?<Tag icon={<CheckCircleOutlined />} color="#87d068">Active</Tag>:<Tag icon={<CloseCircleOutlined />} color="#f50">In Active</Tag>}
        </>
      ),
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'InActive',
          value: false,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => 
      {
        // === is not work
        return record.isActive === value;
      },
      
    },
    {
      title:`Action     `,
      dataIndex: 'action',
      render: (text, rowData) => (
        <span>
          
            {/* <EyeOutlined   className={'viewSamplTypeIcon'} type="eye" 
              onClick={() => { props.viewState(rowData, true); }}
              style={{ color: '#1890ff', fontSize: '14px' }}
            /> */}
         
          {/* <Divider type="vertical" /> */}
          
          <EditOutlined  className={'editSamplTypeIcon'}  type="edit" 
              onClick={() => {
                if (rowData.isActive) {
                   openFormWithData(rowData);
                } else {
                   AlertMessages.getErrorMessage('You Cannot Edit Deactivated Taxes');
                }
              }}
              style={{ color: '#1890ff', fontSize: '14px' }}
            />

          
          <Divider type="vertical" />
            <Popconfirm 
            onConfirm={e => { deleteTax(rowData);  }}
            title={
              rowData.isActive
                ? 'Are you sure to Deactivate Tax ?'
                :  'Are you sure to Activate Tax ?'
            }
          >
            <Switch  size="default"
                className={ rowData.isActive ? 'toggle-activated' : 'toggle-deactivated' }
                checkedChildren={<RightSquareOutlined type="check" />}
                unCheckedChildren={<RightSquareOutlined type="close" />}
                checked={rowData.isActive}
              />
            
          </Popconfirm>
        </span>
      )
    }
  ];
  function onChange(pagination, filters, sorter, extra) {
    console.log('params', pagination, filters, sorter, extra);
  }
     //drawer related
     const closeDrawer=()=>{
      setDrawerVisible(false);
    }

    const openFormWithData=(viewData: TaxesDto)=>{
      setDrawerVisible(true);
      setSelectedTaxesData(viewData);
    };

  return (
    <>
    <Card title={<span style={{color:'white'}}>Taxes</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={<Link to='/taxes-form' ><span style={{color:'white'}} ><Button className='panel_button' >Create </Button> </span></Link>} >
    <br></br>
    <Row gutter={40}>
     
         <Card title={'Total Taxes: ' + taxesData.length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#bfbfbf'}}></Card>
         
          <Card title={'Active: ' + taxesData.filter(el => el.isActive).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#52c41a'}}></Card>
         
          <Card title={'In-Active: ' + taxesData.filter(el => el.isActive == false).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#f5222d'}}></Card>
         
         </Row><br></br>
     
        <Table
            rowKey={record => record.stateId}
            columns={sampleTypeColumns}
            scroll = {{x:true}}
            dataSource={taxesData}
              pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          onChange={onChange} 
            bordered
          />
          <Drawer bodyStyle={{ paddingBottom: 80 }} title='Update' width={window.innerWidth > 768 ? '50%' : '85%'}
            onClose={closeDrawer} visible={drawerVisible} closable={true}>
            <Card headStyle={{ textAlign: 'center', fontWeight: 500, fontSize: 16 }} size='small'>
              <TaxesForm key={Date.now()}
                updateTax={updateTax}
                isUpdate={true}
                taxesData={selectedTaxesData}
                closeForm={closeDrawer} />
            </Card>
          </Drawer>
      </Card>
        </>
  );

};


export default TaxesGrid;

